export default "__VITE_ASSET__Bb6MiUc5__"